import React from 'react';
import { LargeVideo } from 'types/studio/studio';
import { Typography } from '@ag1/ui';
import { vars } from '@ag1/ui/theme';
import clsx from 'clsx';
import styles from './LargeVideoHeading.module.scss';

type Props = Pick<
  LargeVideo,
  'headline' | 'subtitle' | 'textColor' | 'contentAlignment' | 'mobileContentAlignment'
>;

const LargeVideoHeading = ({
  subtitle,
  headline,
  textColor: textColorProp = 'primary',
  contentAlignment = 'left',
  mobileContentAlignment = 'left'
}: Props) => {
  const textColor =
    textColorProp && textColorProp in vars.colors.text
      ? vars.colors.text[textColorProp as keyof typeof vars.colors.text]
      : vars.colors.text.primary;

  return (
    <div
      className={clsx(styles.root, {
        [styles.center]: contentAlignment === 'center',
        [styles.leftMobile]: mobileContentAlignment === 'left',
        [styles.centerMobile]: mobileContentAlignment === 'center'
      })}>
      {headline && (
        <Typography
          component="h2"
          variant="headlineSans"
          size="2"
          noPadding
          className={styles.headline}
          style={{ color: textColor }}>
          {headline}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="subtitle" size="1" noPadding style={{ color: textColor }}>
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default LargeVideoHeading;
